<template>
<keep-alive>
  <div id="login_container">

  </div>
  </keep-alive>
</template>

<script>
export default {
  activated() {
    const that = this;
    const appid = 'dingxkpwvqjwzlkqy0rg';
    const host = 'https://a.inbgz.com';
    const url = encodeURIComponent(`${host}/oauth2`);
    const goto = encodeURIComponent(`https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${appid}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=` + url);
    // ding event
    const handleMessage = function(event) {
      const origin = event.origin;
      if (origin == 'https://login.dingtalk.com') { // 判断是否来自ddLogin扫码事件。
        const loginTmpCode = event.data;
        // 获取到loginTmpCode后就可以在这里构造跳转链接进行跳转了
        const redirect_url = encodeURIComponent(host);
        window.location.href = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${appid}&response_type=code&scope=snsapi_login&state=0&redirect_uri=${redirect_url}&loginTmpCode=${loginTmpCode}`;
      }
    };


    const obj = DDLogin({
      id: 'login_container', // 这里需要你在自己的页面定义一个HTML标签并设置id，例如<div id="login_container"></div>或<span id="login_container"></span>
      goto,
      width: 200,
      height: 160,
    });

    if (typeof window.addEventListener != 'undefined') {
      window.addEventListener('message', handleMessage, false);
    } else if (typeof window.attachEvent != 'undefined') {
      window.attachEvent('onmessage', handleMessage);
    }
  },
};
</script>

<style lang="scss" scoped>

</style>
